module.exports = __webpack_public_path__ + "img/giropay.4472165e.png";